import React from 'react'
import { Global, css } from '@emotion/react'

import Header from './components/Header'
import Main from './components/Main'
import Footer from './components/Footer'
import Base from './Base'

// Component
const Default = (props) => {
  return (
    <Base {...props}>
      <Global
        styles={css`
        .invoice-details .label,
        .total-amount,
        .description .label,
        .note .label,
        .invoice-table thead th {
          color: ${props.invoiceSettings.accentColor};
        }
        `}
      />
      <Header {...props} />
      <Main {...props} />
      <Footer {...props} />
    </Base>
  )
}

export default Default
